//@import dependencies
import React from 'react'
import { useTranslation } from 'react-i18next'
//@end

//@import components
// import {AppLayout} from 'app_components/layouts/app'
//@end

// @import hooks
import {useColors} from 'app_hooks/useColors'
// @end

// @INFO Import types
// @end

// @INFO Import services
// @end

// @INFO Import Styles
import './../defaultHomeModule.scss'

// @ADD Component types
interface IDefaultHomeModuleLayoutProps {
  user: any,
  onHandleApiConnect: any
  onHandleSocketConnect: any
  onHandleChangeLanguaje: any
  onHandleGoToPage: any
  onHandleChangeTheme: any
  onHandleLogout: any
}

const DefaultHomeModuleLayout: React.FC<IDefaultHomeModuleLayoutProps> = (props) => {

  const [colors] = useColors()

  const { t } = useTranslation()

  return(
    <div className='container mt-3'>

      <h3 style={{color: colors.text}}>{t('sandbox.home.welcome', {fullname: `${props.user?.data?.profile?.first_name} ${props?.user?.data?.profile?.last_name}`})}</h3>

      <div className=''>
        <button onClick={props.onHandleApiConnect} className='btn btn-primary mr-3'>
          {t('sandbox.home.test_api_connect')}
        </button>

        <button onClick={props.onHandleSocketConnect} className='btn btn-secondary mr-3'>
          {t('sandbox.home.test_socket_connect')}
        </button>

        <button onClick={props.onHandleChangeLanguaje} className='btn btn-info mr-3'>
          {t('sandbox.home.test_i18n')}
        </button>

        <button onClick={props.onHandleGoToPage} className='btn btn-warning mr-3'>
          {t('sandbox.home.test_go_to_page')}
        </button>

        <button onClick={props.onHandleChangeTheme} className='btn btn-primary mr-3'>
          {props.user.data?.screen_mode === 'light-mode'
            ? t('sandbox.home.theme_dark')
            : t('sandbox.home.theme_light')
          }
        </button>

        <button onClick={props.onHandleLogout} className='btn btn-danger mr-3'>
          {t('sandbox.home.logout')}
        </button>
      </div>
    </div>
  )
}

export default DefaultHomeModuleLayout
